!(function () {
  'use strict';
  const e = {};
  function t(t = {}) {
    if ((t.type || (t.type = 'json'), t.url))
      return e[t.url]
        ? e[t.url]
        : (function (t, n) {
            const s = new Promise((e, s) => {
              'text' === n
                ? fetch(t)
                    .then((e) => e.text())
                    .then((t) => {
                      e(t);
                    })
                    .catch((e) => {
                      s(e);
                    })
                : (function (e, t, n) {
                    let s = document.getElementsByTagName('head')[0],
                      o = !1,
                      r = document.createElement('script');
                    ((r.src = e),
                      (r.onload = r.onreadystatechange =
                        function () {
                          o ||
                          (this.readyState &&
                            'loaded' != this.readyState &&
                            'complete' != this.readyState)
                            ? n()
                            : ((o = !0), t());
                        }),
                      s.appendChild(r));
                  })(
                    t,
                    function () {
                      e();
                    },
                    function () {
                      s();
                    }
                  );
            });
            return ((e[t] = s), s);
          })(t.url, t.type);
    if (t.json)
      return e[t.json]
        ? Promise.resolve(e[t.json])
        : window
            .fetch(t.json)
            .then((e) => e.json())
            .then((n) => ((e[t.json] = n), n));
    if (t.name) {
      const n = ''.concat(t.name, t.version);
      return e[n]
        ? e[n]
        : (function (t) {
            const n = ''.concat(t.name, t.version),
              s = new Promise((e, n) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: (t) => {
                        !(function (e, t, n) {
                          n ? t(n) : e();
                        })(e, n, t);
                      },
                    },
                  ]);
                } catch (e) {
                  n(e);
                }
              });
            return ((e[n] = s), s);
          })(t);
    }
    return Promise.reject();
  }
  window.theme.LoadRellax = window.theme.LoadRellax || null;
  window.theme.LoadRellax = class {
    constructor(e, n, s = '') {
      const o = { center: !0, round: !0, frame: e };
      ((this.options = '' !== s ? s : o),
        (this.selector = n),
        (this.rellaxInstance = null),
        t({ url: window.theme.assets.rellax })
          .then(() => this.init())
          .catch((e) => console.error(e)));
    }
    init() {
      const e = window.themeRellax?.Rellax || window.Rellax;
      this.rellaxInstance = new e(this.selector, this.options);
    }
    refresh() {
      this.rellaxInstance?.refresh
        ? this.rellaxInstance.refresh()
        : console.warn('Rellax instance is not initialized yet.');
    }
    destroy() {
      this.rellaxInstance?.destroy &&
        (this.rellaxInstance.destroy(),
        this.selector instanceof Element && (this.selector.style.transform = ''),
        (this.rellaxInstance = null));
    }
  };
})();
